import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Card } from 'react-bootstrap-5';

import './styles.scss';

export default function ApexCard({
  children,
  className,
  controls,
  fullWidth,
  label,
  labelControls,
  overflowAuto,
  required,
  verticalBody
}) {
  return (
    <Card className={classNames('apex-card', className, { 'full-width': fullWidth, 'panel-required': required })}>
      {label &&
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-row align-items-center">
            <Card.Title className="fs-body fw-semibold mb-0 me-3">
              {label}
            </Card.Title>
            {labelControls && <div>{labelControls}</div>}
          </div>

          <div>
            {controls}
          </div>
        </Card.Header>
      }

      <Card.Body className={classNames({ 'd-flex flex-column': verticalBody, 'overflow-auto': overflowAuto })}>
        {children}
      </Card.Body>
    </Card>
  );
}

ApexCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  controls: PropTypes.node,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  labelControls: PropTypes.node,
  overflowAuto: PropTypes.bool,
  required: PropTypes.bool,
  verticalBody: PropTypes.bool,
};
